import {
    openOrderFormLayerAction, setErrorMessageAction, unsetErrorMessageAction,
    closePostcodeLayerAction, closeProductLayerAction, closeOrderStatusLayerAction
} from '../../_flux/actions/product_mixed_stocks_lightbox_actions';
import Cart from '../../_flux/stores/models/cart';
import ProductMixedStocksLightboxStore from '../../_flux/stores/product_mixed_stocks_lightbox_store';

export default function onCallForAlternativeStockClick() {
    return () => {
        unsetErrorMessageAction();
        const {cart, fittingOptions, withoutFittingOption} = ProductMixedStocksLightboxStore.getState();
        if (cart instanceof Cart) {
            if (fittingOptions.length <= 0 && false === withoutFittingOption) {
                setErrorMessageAction('product-mixed-stocks-select-no-fitting-message');
                return;
            }
        }

        closePostcodeLayerAction();
        closeProductLayerAction();
        closeOrderStatusLayerAction();
        openOrderFormLayerAction();
    };
}
